const FILENAME_UNSAFE = /[<>:"/\\|?*\u0000-\u001f]/g;

function sanitizeFilenameSegment(segment: string): string {
  const cleaned = segment.replace(FILENAME_UNSAFE, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  return cleaned.length > 0 ? cleaned : 'unknown';
}

/** Base filename without `.pdf` for syllabus download / iframe title. */
export function buildSyllabusPdfDownloadBaseName(
  programKey: string,
  programContentVersion: string | null | undefined
): string {
  const safeKey = sanitizeFilenameSegment(programKey.trim());
  const version = programContentVersion?.trim();
  if (!version) {
    return `syllabus-${safeKey}`;
  }
  return `syllabus-${safeKey}-${sanitizeFilenameSegment(version)}`;
}

/** PDF Document keywords for program content release (machine-friendly). */
export function buildSyllabusPdfKeywords(programContentVersion: string | null | undefined): string | undefined {
  const version = programContentVersion?.trim();
  if (!version) {
    return undefined;
  }
  return `programContentVersion:${version}`;
}
